<template>
  <component
      :is="componentName"
      v-bind="propsFor(componentName)"
      class="LINK"
  >
    <slot/>
    <vk-icon v-if="exact" name="chevronright" class="d-none:t c-depot"/>
  </component>
</template>

<script>
const ANCHOR = 'a';
const ROUTER_LINK = 'router-link';

export default {
  name: 'about-menu-link',
  props: {
    link: {
      type: Object,
    },
    href: {
      type: String,
    },
    target: {
      type: String,
    },
    exact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    componentName () {
      return this.href ? ANCHOR : ROUTER_LINK;
    },
  },
  methods: {
    propsFor (componentName) {
      return componentName === ANCHOR ? {
        href: this.href,
        target: this.target,
      } : {
        to: this.link,
        exact: this.exact,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .LINK {
    @include padding-x(2);
    @include padding-y(1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: $color-gray70;
    text-decoration: none;
    &.router-link-active,
    &:hover {
      color: $color-gray90;
    }
    &.router-link-exact-active {
      border-right: 4px solid $color-depot;
    }
  }
</style>
